import dayjs from 'dayjs'

import errorMessages from '../../constants/errorMessages'

const isFilterDate = (date: dayjs.Dayjs, filter: (date: Date) => boolean): [boolean, string] => {
  return [filter(date.toDate()), errorMessages.FILTER_DATE_EXCEPTION]
}

export default isFilterDate
